<template>
  <el-row class="dish-library-management" :gutter="24" style="background: transparent; min-height: 100vh">
    <management-toolbar><el-button type="primary" icon="el-icon-plus" :disabled="savingMenu" @click="newGroup()">Añadir familia</el-button></management-toolbar>
    <div class="dish-search-bar">
      <label for="menu-dish-search">Buscar familias o platos</label>
      <el-input id="menu-dish-search" v-model="search" clearable prefix-icon="el-icon-search"
        placeholder="Nombre de familia, plato o descripción" />
      <p role="status">{{ visibleGroups.length }} {{ visibleGroups.length === 1 ? 'familia' : 'familias' }} · {{ visibleDishCount }} {{ visibleDishCount === 1 ? 'plato' : 'platos' }}</p>
    </div>
    <p v-if="!visibleGroups.length" class="dish-search-empty">No hay familias o platos que coincidan con la búsqueda.</p>
    <el-collapse v-model="expandedGroups">
      <el-row v-for="item in visibleGroups" :key="item.key" class="row-collapse-item">
        <el-collapse-item :name="item.key">
          <template slot="title">
            <el-col
              :span="22"
              class="justify-left"
              style="padding-left: 2vw;  color: white"
              ><img v-if="item.iconImage" :src="photoUrl(item.iconImage)" class="family-icon" alt="" />{{ item.name }}</el-col
            >
            <el-col
              :span="2"
              style="
                display: flex;
                align-items: center;
                justify-content: space-around;
                padding: 1vw;
              "
            >
              <el-button
                style="
                  padding: 0vw;
                  border: none;

                  background-color: transparent;
                "
                @click.stop="selectGroup(item)"
               :aria-label="'Editar ' + item.name">
                <i
                  class="el-icon-edit"
                  style=" color: white"
                ></i>
              </el-button>
              <el-button
                style="
                  padding: 0vw;
                  border: none;

                  background-color: transparent;
                "
                v-on:click.stop="selectGroupDelete(item)"
               :aria-label="'Eliminar ' + item.name">
                <i
                  class="el-icon-delete-solid"
                  style=" color: white"
                ></i>
              </el-button>
            </el-col>
          </template>
          <el-row style="padding-top: 1vw">
            <div v-if="item.plu.length" class="library-table-heading" aria-hidden="true"><span>Nombre</span><span>Alérgenos</span><span>Descripción</span><span>Acciones</span></div>
            <el-row v-for="plu in item.plu" :key="plu.key" class="library-dish-row">
              <!--PLU-->
              <div class="library-dish-name"><img v-if="plu.image" :src="photoUrl(plu.image)" class="dish-photo-thumbnail" alt="" /><strong>{{ plu.name }}</strong></div>
              <div class="library-dish-allergens"><span class="library-mobile-label">Alérgenos</span><div class="library-allergen-icons">
                 <span v-for="key in plu.alergenos" :key="key">
                  <img
                    v-if="alergenos[key]"
                    class="item-img"
                    :src="alergenos[key].url"
                    :alt="alergenos[key].name" :title="alergenos[key].name"
                  />
                </span>
                <span v-if="!plu.alergenos || !plu.alergenos.length" class="library-empty">Sin indicar</span>
              </div></div>
              <!--DESCRIPCION-->
              <div class="library-dish-description"><span class="library-mobile-label">Descripción</span><span :class="{ 'library-empty': !plu.description }">{{ plu.description || 'Sin descripción' }}</span></div>
              <!--EDIT ICONS-->
              <div class="library-dish-actions">
                <!--MODIFY-->
                <el-button
                  style="padding: 0vw; border: none; "
                  @click="selectPLUEdit(item, plu)"
                 :aria-label="'Editar ' + plu.name">
                  <i
                    class="el-icon-edit"
                    style=" color: black"
                  ></i>
                </el-button>
                <!--DELETE-->
                <el-button
                  style="
                    padding: 0vw;
                    border: none;

                    color: #37474f;
                  "
                  v-on:click="selectPLUDelete(item, plu)"
                 :aria-label="'Eliminar ' + plu.name">
                  <i
                    class="el-icon-delete-solid"
                    style=" color: black"
                  ></i>
                </el-button>
              </div>
            </el-row>
            <!--Nuevo PLU-->
            <el-row class="new-row-internal">
              <el-button
                v-on:click="selectPLUNew(item)"
                style="padding: 0vw; border: none; "
              >
                <i class="el-icon-plus" /> Añadir plato
              </el-button>
            </el-row>
          </el-row>
        </el-collapse-item>
      </el-row>
    </el-collapse>
    <!--DIALOGS-->
    <el-row>
      <!--DIALOG EDIT PLU-->
      <el-dialog
        title="Editar plato"
        :visible.sync="dialogEdit"
        width="70%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-dialog
          width="30%"
          title="Añada el Nombre del PLU por favor"
          :visible.sync="notName"
          append-to-body
        ></el-dialog>
        <span class="row-dialog-newPLU">
          <span class="management-field"><label for="platosmenu-field-0">Nombre</label><el-input
            placeholder="Nombre"
            v-model="name"
           id="platosmenu-field-0"></el-input></span>
        </span>
        <!--Alergenos-->
        <span>
          <div
            style="

              color: black;
              text-align: left;
              margin-left: 3vw;
              margin-top: 2vh;
              margin-bottom: 2vh;
            "
          >
            Alérgenos
          </div>
          <div>
            <el-checkbox-group v-model="alergenosSeleccionados">
              <el-checkbox-button
                v-for="alergeno in alergenos" :aria-label="alergeno.name"
                :label="alergeno.key"
                :key="alergeno.key"
              >
                <img class="dialog-alergen" v-if="alergeno" :src="alergeno.url" :alt="alergeno.name" />
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </span>

        <span class="row-dialog-newPLU">
          <span class="management-field"><label for="platosmenu-field-1">Descripción</label><el-input type="textarea" :rows="2"
            placeholder="Descripcion"
            v-model="description"
           id="platosmenu-field-1"></el-input></span>
        </span>
        <dish-photo-upload v-if="dialogEdit" :key="photoSession" ref="editPhoto" v-model="image" />
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogEdit = false"
            :disabled="savingPhoto"
          >
            Cancelar
          </el-button>
          <el-button
            v-on:click="savePLU()"
            :loading="savingPhoto"
           type="primary">
            Guardar
          </el-button>
        </span>
      </el-dialog>
      <!--DIALOG DELETE PLU-->
      <el-dialog
        title="Eliminar plato"
        :visible.sync="dialogDelete"
        width="70%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-dialog
          width="30%"
          title="El articulo forma parte de un menú, no es posible eliminar."
          :visible.sync="dialogDeleteError"
          append-to-body
        ></el-dialog>
        ¿Desea eliminar el articulo {{ name }}?
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogDelete = false"
          >
            Cancelar
          </el-button>
          <el-button
            v-on:click="deletePLU()"
           type="danger">Eliminar</el-button>
        </span>
      </el-dialog>
      <!--DIALOG NEW PLU-->
      <el-dialog
        title="Nuevo plato"
        :visible.sync="dialogNew"
        width="70%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-dialog
          width="30%"
          title="Añada el Nombre del PLU por favor"
          :visible.sync="notName"
          append-to-body
        ></el-dialog>
        <span class="row-dialog-newPLU">
          <span class="management-field"><label for="platosmenu-field-2">Nombre</label><el-input
            placeholder="Nombre"
            v-model="name"
           id="platosmenu-field-2"></el-input></span>
        </span>
        <!--Alergenos-->
        <span>
          <div
            style="

              color: black;
              text-align: left;
              margin-left: 3vw;
              margin-top: 2vh;
              margin-bottom: 2vh;
            "
          >
            Alérgenos
          </div>
          <div>
            <el-checkbox-group v-model="alergenosSeleccionados">
              <el-checkbox-button
                v-for="alergeno in alergenos" :aria-label="alergeno.name"
                :label="alergeno.key"
                :key="alergeno.key"
              >
                <img class="dialog-alergen" v-if="alergeno" :src="alergeno.url" :alt="alergeno.name" />
              </el-checkbox-button>
            </el-checkbox-group>
          </div>
        </span>

        <span class="row-dialog-newPLU">
          <span class="management-field"><label for="platosmenu-field-3">Descripción</label><el-input type="textarea" :rows="2"
            placeholder="Descripcion"
            v-model="description"
           id="platosmenu-field-3"></el-input></span>
        </span>
        <dish-photo-upload v-if="dialogNew" :key="photoSession" ref="newPhoto" v-model="image" />
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogNew = false"
            :disabled="savingPhoto"
          >
            Cancelar
          </el-button>
          <el-button
            v-on:click="addNewPLU()"
            :loading="savingPhoto"
           type="primary">
            Guardar
          </el-button>
        </span>
      </el-dialog>
      <!--DIALOG NEW GROUP-->
      <el-dialog
        title="Nueva familia"
        :visible.sync="dialogNewGroup"
        width="70%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-dialog
          width="30%"
          title="Añada el Nombre del PLU por favor"
          :visible.sync="notName"
          append-to-body
        ></el-dialog>
        <span class="row-dialog-newPLU">
          <span class="management-field"><label for="platosmenu-field-4">Nombre</label><el-input
            placeholder="Nombre"
            v-model="name"
           id="platosmenu-field-4"></el-input></span>
        </span>
        <custom-icon-picker v-if="dialogNewGroup" :key="'newFamilyIcon-'+iconSession" ref="newFamilyIcon" v-model="iconImage" />
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogNewGroup = false"
          >
            Cancelar
          </el-button>
          <el-button
            v-on:click="addGroup()"
           type="primary">
            Guardar
          </el-button>
        </span>
      </el-dialog>
      <!--DIALOG EDIT GROUP-->
      <el-dialog
        title="Editar familia"
        :visible.sync="dialogEditGroup"
        width="70%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-dialog
          width="30%"
          title="Añada el nombre del grupo, por favor."
          :visible.sync="notName"
          append-to-body
        ></el-dialog>
        <span class="row-dialog-newPLU">
          <span class="management-field"><label for="platosmenu-field-5">Nombre</label><el-input
            placeholder="Nombre"
            v-model="name"
           id="platosmenu-field-5"></el-input></span>
        </span>
        <custom-icon-picker v-if="dialogEditGroup" :key="'editFamilyIcon-'+iconSession" ref="editFamilyIcon" v-model="iconImage" />
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogEditGroup = false"
          >
            Cancelar
          </el-button>
          <el-button
            v-on:click="editGroup()"
           type="primary">
            Guardar
          </el-button>
        </span>
      </el-dialog>
      <!--DIALOG DELETE GROUP-->
      <el-dialog
        title="Eliminar familia"
        :visible.sync="dialogDeleteGroup"
        width="70%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-dialog
          width="30%"
          title="El grupo forma parte de un menú, no es posible eliminar."
          :visible.sync="dialogDeleteError"
          append-to-body
        ></el-dialog
        >¿Desea eliminar el grupo?
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogDeleteGroup = false"
          >
            Cancelar
          </el-button>
          <el-button
            v-on:click="deleteGroup()"
           type="danger">Eliminar</el-button>
        </span>
      </el-dialog>
    </el-row>
  </el-row>
</template>
<script>
import * as api from "../api/request.js";
import storage from "../api/storage.js";
import DishPhotoUpload from "../components/DishPhotoUpload.vue";
import CustomIconPicker from '../components/CustomIconPicker.vue';
import ManagementToolbar from "../components/ManagementToolbar.vue";
import { filterDishGroups } from "../utils/menuDishes";
export default {
  components: { DishPhotoUpload, ManagementToolbar, CustomIconPicker },
  data() {
    return {
      image: "",
      iconImage:"",
      iconSession:0,
      photoSession: 0,
      savingPhoto: false,
      savingMenu: false,
      pendingMenuSave: false,
      search: "",
      activeGroups: [],
      groupSelected: 0,
      pluSelected: 0,
      name: "",
      description: "",
      dialogEdit: false,
      dialogDelete: false,
      dialogNew: false,
      dialogNewGroup: false,
      dialogEditGroup: false,
      dialogDeleteGroup: false,
      dialogDeleteError: false,
      notName: false,
      alergenosSeleccionados: [],
      alergenos: [],
      data: [],
      menu: [],
      version: undefined,
    };
  },
  mounted() {
    this.authenticated = storage.loadAuthenticated();
    if (this.authenticated === false || this.authenticated === null) {
      this.$router.replace({ name: "login" });
    } else {
      this.loadData();
    }
  },
  computed: {
    visibleGroups() { return filterDishGroups(this.data, this.search); },
    visibleDishCount() { return this.visibleGroups.reduce((sum, group) => sum + group.plu.length, 0); },
    expandedGroups: {
      get() { return this.search.trim() ? this.visibleGroups.map(group => group.key) : this.activeGroups; },
      set(value) { this.activeGroups = value; }
    },
    getData: function () {
      return this.data;
    },
  },
  methods: {
    photoUrl: api.imageUrl,
    handleNodeClick(data) {
      console.log(data);
    },
    loadData: async function () {
      const snapshot = await api.getMenuCompleto();
      this.menu = snapshot.menus;
      this.data = snapshot.grupos;
      this.version = snapshot.version;
      this.alergenos = await api.getAlergenos();
    },
    setData: async function () {
      if (this.savingMenu) { this.pendingMenuSave = true; return false; }
      this.savingMenu = true;
      try {
        do {
          this.pendingMenuSave = false;
          const result = await api.setMenuCompleto(JSON.parse(JSON.stringify(this.data)), JSON.parse(JSON.stringify(this.menu)), this.version);
          this.version = result.version;
        } while (this.pendingMenuSave);
        return true;
      } catch (error) {
        this.$message.error("No se han guardado los cambios. Recargando los datos.");
        this.dialogEdit = false;
        this.dialogNew = false;
        await this.loadData();
        return false;
      } finally { this.savingMenu = false; this.pendingMenuSave = false; }
    },
    moveUPPLU: function (item, plu) {
      var copy = Object.assign({}, plu);
      if (plu.key > 0) {
        this.data[item.key].plu[plu.key].name = this.data[item.key].plu[
          plu.key - 1
        ].name;
        this.data[item.key].plu[plu.key].description = this.data[item.key].plu[
          plu.key - 1
        ].description;
        this.data[item.key].plu[plu.key].alergenos = this.data[item.key].plu[
          plu.key - 1
        ].alergenos;
        this.data[item.key].plu[plu.key].enable = this.data[item.key].plu[
          plu.key - 1
        ].enable;

        this.data[item.key].plu[plu.key - 1].name = copy.name;
        this.data[item.key].plu[plu.key - 1].description = copy.description;
        this.data[item.key].plu[plu.key - 1].alergenos = copy.alergenos;
        this.data[item.key].plu[plu.key - 1].enable = copy.enable;
        this.setData();
      }
    },
    moveDOWNPLU: function (item, plu) {
      var copy = Object.assign({}, plu);
      if (plu.key < item.plu.length - 1) {
        this.data[item.key].plu[plu.key].name = this.data[item.key].plu[
          plu.key + 1
        ].name;
        this.data[item.key].plu[plu.key].description = this.data[item.key].plu[
          plu.key + 1
        ].description;
        this.data[item.key].plu[plu.key].alergenos = this.data[item.key].plu[
          plu.key + 1
        ].alergenos;
        this.data[item.key].plu[plu.key].enable = this.data[item.key].plu[
          plu.key + 1
        ].enable;

        this.data[item.key].plu[plu.key + 1].name = copy.name;
        this.data[item.key].plu[plu.key + 1].description = copy.description;
        this.data[item.key].plu[plu.key + 1].alergenos = copy.alergenos;
        this.data[item.key].plu[plu.key + 1].enable = copy.enable;
        this.setData();
      }
    },
    savePLU: async function () {
      if (this.savingPhoto || this.savingMenu) return;
      if (!this.name.trim()) { this.notName = true; return; }
      this.savingPhoto = true;
      try {
        const image = await this.$refs.editPhoto.upload();
        const group = this.data[this.groupSelected];
        const values = { name: this.name, description: this.description,
          alergenos: this.alergenosSeleccionados.slice(), image };
        this.$set(group.plu, this.pluSelected, { ...group.plu[this.pluSelected], ...values });
        if (await this.setData()) { this.dialogEdit = false; this.dialogNew = false; }
      } catch (error) { this.$message.error("No se ha guardado el plato. Comprueba la imagen e inténtalo de nuevo."); }
      finally { this.savingPhoto = false; }
    },
    selectPLUNew: function (item) {
      this.groupSelected = item.key;
      this.image = "";
      this.photoSession += 1;
      this.name = "";
      this.description = "";
      this.alergenosSeleccionados = [];
      this.dialogNew = true;
    },
    selectPLUEdit: function (item, plu) {
      this.groupSelected = item.key;
      this.pluSelected = plu.key;
      this.image = plu.image || "";
      this.photoSession += 1;
      this.name = plu.name;
      this.description = plu.description;
      this.alergenosSeleccionados = (plu.alergenos || []).slice();
      this.dialogEdit = true;
    },
    selectPLUDelete: function (item, plu) {
      this.groupSelected = item.key;
      this.pluSelected = plu.key;
      this.name = plu.name;
      this.dialogDelete = true;
    },
    deletePLU: function () {
      let aux = true;
      for (let i = 0; i < this.menu.length && aux; i++) {
        for (let j = 0; j < this.menu[i].groups.length && aux; j++) {
          for (let k = 0; k < this.menu[i].groups[j].plu.length && aux && this.menu[i].groups[j].keyOriginal == this.groupSelected; k++) {
            if (this.menu[i].groups[j].plu[k] == this.pluSelected) aux = false;
          }
        }
      }
      if (aux) {
        this.data[this.groupSelected].plu.splice(this.pluSelected, 1);
        //Actualizar las key
        var num = 0;
        this.data[this.groupSelected].plu.forEach((plu) => {
          plu.key = num;
          num++;
        });
        this.dialogDelete = false;
        for (let i = 0; i < this.menu.length && aux; i++) {
        for (let j = 0; j < this.menu[i].groups.length && aux; j++) {
          for (let k = 0; k < this.menu[i].groups[j].plu.length && aux && this.menu[i].groups[j].keyOriginal == this.groupSelected; k++) {
            if (this.menu[i].groups[j].plu[k] > this.pluSelected) this.menu[i].groups[j].plu[k] -= 1;
          }
        }
      }
        this.setData();
      } else {
        this.dialogDeleteError = true;
      }
    },
    addNewPLU: async function () {
      if (this.savingPhoto || this.savingMenu) return;
      if (!this.name.trim()) { this.notName = true; return; }
      this.savingPhoto = true;
      try {
        const image = await this.$refs.newPhoto.upload();
        const group = this.data[this.groupSelected];
        const values = { name: this.name, description: this.description,
          alergenos: this.alergenosSeleccionados.slice(), image };
        group.plu.push({ ...values, key: group.plu.length, enable: true });
        if (await this.setData()) { this.dialogEdit = false; this.dialogNew = false; }
      } catch (error) { this.$message.error("No se ha guardado el plato. Comprueba la imagen e inténtalo de nuevo."); }
      finally { this.savingPhoto = false; }
    },
    addGroup: async function () {
      if(this.savingMenu || this.savingPhoto)return;
      if(!this.name.trim())return this.$message.error("Indica el nombre de la familia.");
      this.savingPhoto=true;
      try{this.iconImage=await this.$refs.newFamilyIcon.upload();}catch(e){return this.$message.error("No se pudo guardar el icono.");}finally{this.savingPhoto=false;}
      this.data.push({
        name: this.name,
        iconImage:this.iconImage,
        key: this.data.length,
        plu: [],
      });
      this.dialogNewGroup = false;
      this.setData();
    },
    newGroup: function () {
      this.iconImage="";this.iconSession++;
      this.name = "";
      this.dialogNewGroup = true;
    },
    editGroup: async function () {
      if(this.savingMenu || this.savingPhoto)return;
      if(!this.name.trim())return this.$message.error("Indica el nombre de la familia.");
      this.savingPhoto=true;
      try{this.iconImage=await this.$refs.editFamilyIcon.upload();}catch(e){return this.$message.error("No se pudo guardar el icono.");}finally{this.savingPhoto=false;}
      this.$set(this.data[this.groupSelected],"iconImage",this.iconImage);
      this.data[this.groupSelected].name = this.name;
      this.dialogEditGroup = false;
      this.setData();
    },
    selectGroup: function (grupo) {
      this.iconImage=grupo.iconImage || "";this.iconSession++;
      this.name = grupo.name;
      this.groupSelected = grupo.key;
      this.dialogEditGroup = true;
    },
    selectGroupDelete: function (item) {
      this.groupSelected = item.key;
      this.dialogDeleteGroup = true;
    },
    deleteGroup: function () {
      let aux = true;
      for (let i = 0; i < this.menu.length && aux; i++) {
        for (let j = 0; j < this.menu[i].groups.length && aux; j++) {
          if (this.menu[i].groups[j].keyOriginal == this.groupSelected) {
            aux = false;
          }
        }
      }
      if (aux) {
        this.data.splice(this.groupSelected, 1);
        this.menu.forEach(menu => menu.groups.forEach(group => {
          if (group.keyOriginal > this.groupSelected) group.keyOriginal -= 1;
        }));
        for (let i = this.groupSelected; i < this.data.length; i++) {
          this.data[i].key = i;
        }
      } else {
        this.dialogDeleteError = true;
      }
      this.dialogDeleteGroup = false;
      this.setData();
    },
  },
};
</script>

<style scoped>
.family-icon{width:30px;height:30px;object-fit:contain;vertical-align:middle;margin-right:10px}
.dish-photo-thumbnail { width: 44px; height: 36px; object-fit: cover; border-radius: 6px; margin-right: 8px; vertical-align: middle; }
.library-table-heading, .library-dish-row { display: grid; grid-template-columns: minmax(0, 1fr) 160px minmax(0, 1.4fr) 90px; gap: 20px; align-items: center; padding: 16px 12px; text-align: left; }
.library-table-heading { background: #edf2f0; border-radius: 8px; font-size: 12px; font-weight: 700; color: #526f60; }
.library-dish-row { border-bottom: 1px solid #edf1ef; font-size: 14px; line-height: 1.6; }
.library-dish-row::before, .library-dish-row::after { display: none; }
.library-dish-row > div { min-width: 0; overflow-wrap: anywhere; }
.library-dish-name { display: flex; align-items: center; gap: 8px; }
.library-dish-name img { flex-shrink: 0; margin: 0; }
.library-allergen-icons { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; }
.library-allergen-icons img { display: block; margin: 0; width: 26px; height: 26px; object-fit: contain; }
.library-dish-actions { display: flex; gap: 8px; justify-content: flex-end; }
.library-dish-actions .el-button { margin: 0; }
.library-dish-description, .library-empty { color: #687780; }
.library-mobile-label { display: none; }
@media(max-width:760px) {
  .library-table-heading { display: none; }
  .library-dish-row { grid-template-columns: minmax(0, 1fr) 90px; gap: 12px; padding: 18px 0; }
  .library-dish-name { grid-column: 1; grid-row: 1; }
  .library-dish-actions { grid-column: 2; grid-row: 1; }
  .library-dish-allergens, .library-dish-description { grid-column: 1 / -1; }
  .library-mobile-label { display: block; margin-bottom: 4px; font-size: 12px; font-weight: 700; color: #526f60; }
}
.dish-search-bar { width: 100%; margin: 0 0 20px; padding: 18px; background: #fff; border-radius: 12px; text-align: left; }
.dish-search-bar label { display: block; font-size: 15px; font-weight: 600; color: #37474f; margin-bottom: 10px; }
.dish-search-bar p { margin: 10px 0 0; font-size: 13px; color: #606b72; }
.dish-search-empty { width: 100%; margin: 0 0 16px; padding: 18px; background: #fff; border-radius: 12px; color: #606b72; }
</style>
